import React from 'react';

// End-on view of a label roll: an empty bobbin at 0 layers, one ring added per
// poll ("varje gång vi hämtar status"), alternating grafokett-blue/orange like
// wound label stock. Wraps back to an empty bobbin after 25 layers.
const MAX_LAYERS = 25;
const BOBBIN_RADIUS = 14;
const LAYER_GAP = 1.6;
const LAYER_STROKE_WIDTH = 1.4;
const COLORS = ['#0f4164', '#f5910a']; // grafokett-blue, grafokett-orange

const LabelRoll = ({ layers = 0 }) => {
  const clampedLayers = Math.max(0, Math.min(layers, MAX_LAYERS));
  const ringIndexes = Array.from({ length: clampedLayers }, (_, index) => index);

  return (
    <div className="flex flex-col items-center">
      <svg viewBox="0 0 120 120" className="w-16 h-16" role="img" aria-label={`Fetching status — layer ${clampedLayers} of ${MAX_LAYERS}`}>
        {ringIndexes.map((index) => (
          <circle
            key={index}
            cx="60"
            cy="60"
            r={BOBBIN_RADIUS + (index + 1) * LAYER_GAP}
            fill="none"
            stroke={COLORS[index % COLORS.length]}
            strokeWidth={LAYER_STROKE_WIDTH}
          />
        ))}
        <circle cx="60" cy="60" r={BOBBIN_RADIUS} className="fill-current text-gray-200 dark:text-gray-700" />
        <circle cx="60" cy="60" r={BOBBIN_RADIUS} fill="none" className="stroke-current text-gray-400 dark:text-gray-500" strokeWidth="1" />
      </svg>
      <span className="text-xs text-gray-500 dark:text-gray-400 mt-1">
        Layer {clampedLayers} / {MAX_LAYERS}
      </span>
    </div>
  );
};

export default LabelRoll;
